import type { ChildGender } from '../types/profile'

export interface Option {
  emoji: string
  label: string
}

export const OTHER_INTEREST = 'Algo diferente'

const BOY_FIRST: Option[] = [
  { emoji: '🦖', label: 'Dinosaurios' },
  { emoji: '🤖', label: 'Robots' },
  { emoji: '🚀', label: 'Espacio' },
  { emoji: '🚗', label: 'Vehículos' },
]

const GIRL_FIRST: Option[] = [
  { emoji: '👑', label: 'Princesas' },
  { emoji: '🧚', label: 'Hadas' },
  { emoji: '🐶', label: 'Animales' },
  { emoji: '🎨', label: 'Dibujar' },
]

const ALL_INTERESTS: Option[] = [
  { emoji: '🦖', label: 'Dinosaurios' },
  { emoji: '🤖', label: 'Robots' },
  { emoji: '🚀', label: 'Espacio' },
  { emoji: '🚗', label: 'Vehículos' },
  { emoji: '🐶', label: 'Animales' },
  { emoji: '🎨', label: 'Dibujar' },
  { emoji: '⚽', label: 'Deportes' },
  { emoji: '🌳', label: 'Naturaleza' },
  { emoji: '🧩', label: 'Rompecabezas' },
  { emoji: '📚', label: 'Historias' },
  { emoji: '🧙', label: 'Fantasía' },
  { emoji: '🎵', label: 'Música' },
  { emoji: '👑', label: 'Princesas' },
  { emoji: '🧚', label: 'Hadas' },
]

export function getInterestOptions(gender: ChildGender): Option[] {
  const priority = gender === 'hija' ? GIRL_FIRST : BOY_FIRST
  const priorityLabels = priority.map((o) => o.label)
  const rest = ALL_INTERESTS.filter((o) => !priorityLabels.includes(o.label))
  return [...priority, ...rest, { emoji: '✨', label: OTHER_INTEREST }]
}

export const AGE_OPTIONS = ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13+']

export const PERSONALITY_OPTIONS: Option[] = [
  { emoji: '💡', label: 'Muy curioso/a' },
  { emoji: '🌈', label: 'Imaginativo/a' },
  { emoji: '💜', label: 'Sensible' },
  { emoji: '⚡', label: 'Lleno/a de energía' },
  { emoji: '🌱', label: 'Tranquilo/a' },
  { emoji: '😊', label: 'Sociable' },
  { emoji: '🦁', label: 'Valiente' },
  { emoji: '🙈', label: 'Tímido/a al principio' },
  { emoji: '🎯', label: 'Determinado/a' },
  { emoji: '🤔', label: 'Reflexivo/a' },
  { emoji: '✨', label: 'Independiente' },
  { emoji: '🤗', label: 'Cariñoso/a' },
]

export interface PriorityOption extends Option {
  description: string
}

export const PRIORITY_OPTIONS: PriorityOption[] = [
  { emoji: '⭐', label: 'Confianza', description: 'Creer más en sí mismo.' },
  { emoji: '☁️', label: 'Calma', description: 'Recuperar la tranquilidad cuando algo lo frustra.' },
  { emoji: '⚡', label: 'Perseverancia', description: 'Volver a intentarlo cuando algo parece difícil.' },
  { emoji: '🎯', label: 'Enfoque', description: 'Concentrarse mejor y terminar lo que comienza.' },
  { emoji: '💡', label: 'Creatividad', description: 'Confiar en sus ideas y crear nuevas soluciones.' },
]

export const SITUATION_OPTIONS: string[] = [
  'Cuando algo no le sale',
  'Cuando se frustra',
  'Cuando tiene miedo de intentarlo',
  'Cuando aprende algo nuevo',
  'Cuando pierde la concentración',
  'Cuando quiere abandonar rápido',
  'Cuando duda de sí mismo',
  'Ninguna en particular',
]

export const WELCOME_HIGHLIGHTS = [
  { emoji: '⏱️', text: 'Toma aproximadamente 5 minutos' },
  { emoji: '🎧', text: '5 experiencias personalizadas' },
  { emoji: '✨', text: 'Nosotros haremos el resto' },
  { emoji: '💜', text: 'Recibirás todo por correo' },
]
